import { Select } from "antd";
import { SelectProps } from "antd/lib";
import type { BaseSelectRef } from "rc-select";
import * as React from "react";
import { onError } from "src/common/onError";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";
import { ZSidLabel } from "src/types/ZSidLabel";

import { makeAttrSelectOptions } from "../makeAttrSelectOptions";
import { ZAttrSelect } from "./ZAttrComponent";

type PropsAttrEditSelect = {
  select: ZAttrSelect;
  value?: unknown;
  onChange?(value?: unknown): void;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  onBlur: () => void;
};

const opCmp = (a: ZSidLabel, b: ZSidLabel): number =>
  a.label.toLowerCase().localeCompare(b.label.toLowerCase());

export const AttrEditSelect: React.FC<PropsAttrEditSelect> = (props) => {
  const { select, value, onChange, disabled, activateCallback, onBlur } = props;
  const [list, setList] = React.useState<ZSidLabel[]>([]);
  const [loading, setLoading] = React.useState(false);

  // Сейчас фильтрация выполняется только для каталогов значений
  const filterSort =
    select.options.type === "valuesCatalog" ? opCmp : undefined;

  React.useEffect(() => {
    setLoading(true);
    makeAttrSelectOptions(select.options)
      .then((optList) => {
        setList(optList);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch(onError);
  }, [select]);

  const ctrlRef = useActivateCallback<BaseSelectRef>(
    activateCallback,
    (ref) => () => {
      ref?.focus();
    },
  );
  const change = (_v: string, opt: ZSidLabel | ZSidLabel[] | undefined) => {
    if (!Array.isArray(opt)) {
      // Вариант для Select с единичным выбором
      onChange?.(opt);
    }
  };

  return (
    <Select<string, ZSidLabel>
      style={{ width: "100%" }}
      ref={ctrlRef}
      options={list}
      value={
        typeof value === "object" && value && "id" in value
          ? (value.id as string)
          : undefined
      }
      onChange={change}
      {...searchProps(select)}
      filterSort={filterSort}
      fieldNames={{ value: "id" }}
      loading={loading}
      disabled={disabled}
      allowClear
      onBlur={onBlur}
    />
  );
};

const searchProps = (
  comp: ZAttrSelect,
): Pick<SelectProps<string, ZSidLabel>, "filterOption" | "showSearch"> => {
  const { search } = comp;
  if (!search) return {};
  let filterOption: (input: string, option?: ZSidLabel) => boolean;

  // eslint-disable-next-line default-case
  switch (search) {
    case "start":
      filterOption = (input, opt) =>
        opt?.label.toLowerCase().startsWith(input.toLowerCase()) ?? false;
      break;
    case "part":
      filterOption = (input, opt) =>
        opt?.label.toLowerCase().includes(input.toLowerCase()) ?? false;
      break;
  }
  return {
    showSearch: true,
    filterOption,
  };
};
